import { render } from "./StyleCardVertical.vue?vue&type=template&id=17378010"
import script from "./StyleCardVertical.vue?vue&type=script&lang=js"
export * from "./StyleCardVertical.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/StyleCard/StyleCardVertical.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17378010"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17378010', __exports__)) {
    api.reload('17378010', __exports__)
  }
  
  module.hot.accept("./StyleCardVertical.vue?vue&type=template&id=17378010", () => {
    api.rerender('17378010', render)
  })

}


export default __exports__